import { styled } from '@material-ui/core';

export const Header = styled('div')({ cursor: 'pointer' });
